import { useConfig } from 'utils/hooks/useConfig';

export const useCustomThemeFlag = () => {
  const {
    config: { isCustomDesign },
  } = useConfig();

  return {
    isCustomTheme: isCustomDesign,
  };
};

export default useCustomThemeFlag;
